import React from 'react';
import { Link } from 'react-router-dom';
import pci_image from "./assets/pci-dss.webp";
import europcar_img from "./assets/europcar_img.webp";
import logo from "./assets/routeslogo.png";
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-white text-gray-700 border-t border-gray-200">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          
         
          <div>
            <Link to="/">
              <img src={logo} alt="Website Logo" className="h-12 w-auto mb-4" />
            </Link>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b-2 border-yellow-500 inline-block">{t('footer.services')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-yellow-600 transition">{t('footer.rentAVehicle')}</Link></li>
              <li><Link to="/locations" className="hover:text-yellow-600 transition">{t('footer.locationMaps')}</Link></li>
              <li><Link to="/ShuttleRequestTracking" className="hover:text-yellow-600 transition">{t('footer.shuttleTracker')}</Link></li>
            </ul>
          </div>

          {/* Site Map */}
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b-2 border-yellow-500 inline-block">{t('footer.siteMap')}</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-yellow-600 transition">{t('footer.reserveNow')}</Link></li>
              <li><Link to="/locations" className="hover:text-yellow-600 transition">{t('footer.locations')}</Link></li>
              <li><Link to="/rentalpolicy" className="hover:text-yellow-600 transition">{t('footer.rentalPolicies')}</Link></li>
              <li><Link to="/ShuttleRequestTracking" className="hover:text-yellow-600 transition">{t('footer.shuttleTracker')}</Link></li>
              <li><Link to="/SmsPolicy" className="hover:text-yellow-600 transition">{t('footer.smsPrivacy')}</Link></li>
              <li><Link to="/SmsAlerts" className="hover:text-yellow-600 transition">{t('footer.smsAlerts')}</Link></li>
            </ul>
          </div>

          
          <div>
            <h3 className="text-lg font-semibold mb-4 border-b-2 border-yellow-500 inline-block">{t('footer.partnerLinks')}</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="https://www.routesairportparking.com/#Quotes" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-600 transition">{t('footer.routesAirportParking')}</a></li>
              <li><a href="https://www.routesautosales.com/" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-600 transition">{t('footer.routesAutoRemarketing')}</a></li>
              <li><a href="https://routesautohaulage.com/" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-600 transition">{t('footer.routesAutoHaulage')}</a></li>
            </ul>
            <div className="flex items-center space-x-4 mt-6">
              <img src={pci_image} alt="PCI DSS" className="h-10 w-auto" />
              <img src={europcar_img} alt="Europcar" className="h-10 w-auto" />
            </div>
          </div>
        </div>

      
        <div className="mt-12 border-t border-gray-300 pt-4 text-center text-sm text-gray-500">
          © {new Date().getFullYear()} Routes. All copyrights are reserved.
        </div>
      </div>
    </footer>
  );
};


export default Footer;
